'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ShopItem, _Component);

  function ShopItem() {
    (0, _classCallCheck3.default)(this, ShopItem);
    return (0, _possibleConstructorReturn3.default)(this, (ShopItem.__proto__ || (0, _getPrototypeOf2.default)(ShopItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShopItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          active = _props.active,
          _onClick = _props.onClick;

      var styles = require('./ShopItem.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.row, onClick: function onClick() {
            return _onClick(data);
          } },
        _react2.default.createElement('img', {
          className: styles.iconAddress,
          src: _Images2.default.account.address,
          alt: '\u0110\u1ECBa \u0111i\u1EC3m'
        }),
        _react2.default.createElement(
          'span',
          null,
          data.addressDisplay || data.name
        ),
        active ? _react2.default.createElement('img', {
          className: styles.iconRadio,
          src: _Images2.default.payment.checked,
          alt: ''
        }) : _react2.default.createElement('img', {
          className: styles.iconRadio,
          src: _Images2.default.payment.unChecked,
          alt: ''
        })
      );
    }
  }]);
  return ShopItem;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  active: _react.PropTypes.bool,
  onClick: _react.PropTypes.func
}, _temp);
exports.default = ShopItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ShopItem.js
// module id = 1570
// module chunks = 0